import React, { createContext, useState } from 'react';

import MeetEvaluationData from './MeetEvaluationData';

export const MeetEvaluationStateContext = createContext();

const MeetEvaluationContextProvider = ({ children }) => {
  const stateHook = useState(MeetEvaluationData.INITIAL_STATE);

  return (
    <MeetEvaluationStateContext.Provider value={stateHook}>
      {children}
    </MeetEvaluationStateContext.Provider>
  );
};

export default MeetEvaluationContextProvider;